import { IUserProfile } from '@Domains/Profile';
import { ReactNode, createContext, useContext, useState } from 'react';

interface UserContextType {
  user: IUserProfile | undefined;
  setUserProfile: (profile: IUserProfile | undefined) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

interface UserProviderProps {
  children: ReactNode;
  userData?: IUserProfile;
}

export function UserProvider({ children, userData }: UserProviderProps) {
  const [userProfile, setUserProfile] = useState<IUserProfile | undefined>(
    userData
  );

  const setProfile = (profile: IUserProfile | undefined) => {
    setUserProfile(profile);
    if (profile) {
      localStorage.setItem('userProfile', JSON.stringify(profile));
    } else {
      localStorage.removeItem('userProfile');
    }
  };

  return (
    <UserContext.Provider
      value={{ user: userProfile, setUserProfile: setProfile }}
    >
      {children}
    </UserContext.Provider>
  );
}

export function useProfile() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useProfile must be used within a UserProvider');
  }
  return context;
}
